<template>
  <div class="contract">
    <mt-header title="添加签署人">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
      <a @click="save()" slot="right">
        保存
      </a>
    </mt-header>
    <div class="savesigner">
    <mt-field label="签署人姓名" placeholder="请输入签署人姓名" v-model="valiname"></mt-field>
    <mt-field label="签署人手机号" placeholder="请输入签署人手机号" v-model="valimobile"></mt-field>
    <mt-field label="签署人邮箱" placeholder="请输入签署人邮箱" type="email" v-model="valiemail"></mt-field>
    </div>
  </div>
</template>

<script>
import cheader from '@/components/header';
export default {
  data () {
    return {
      valiname:'',
      valimobile:'',
      valiemail:'',
      cid:this.$route.query.cid,
      signerlist:''
    }
  },
  mounted(){
    this.signerlist = this.$route.query.signerlist;
    if(this.signerlist != null && this.signerlist != "" && typeof(this.signerlist) != "undefined" && this.signerlist != "[]"){
      this.signerlist = eval(this.signerlist);
    }else{
      this.signerlist = new Array();
    }
  },
  methods: {
    valiateData: function () {
      if (typeof(this.valiname) == "undefined" ||this.valiname.trim() == "") {
        this.$toast("请填写联系人姓名.");
        return false;
      }
      var mobileReg = /^\d{11}$/;
      if (mobileReg.test(this.valimobile.trim()) === false) {
        this.$toast("请输入正确的手机号.");
        return false;
      }
      var emailReg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
      if(this.valiemail.trim() == ""){
        return true;
      }
      if (emailReg.test(this.valiemail.trim()) === false) {
        this.$toast("请输入正确的邮箱号码.");
        return false;
      }
      return true;
    },
    save: function(){
      var flag = this.valiateData(); // 验证输入框
      if (!flag) {
        return;
      }
      var that = this;
      this.$http.post(
          domain("_getMobile")
      )
      .then(function(response){
        if(that.valimobile == response.data.data.loginCode){
          that.$toast("不能添加本人手机号");
            return;
        }else{
          var row = {'name':that.valiname,'email':that.valiemail,'mobile':that.valimobile};
          (eval(that.signerlist)).push(row);
          that.$router.push({name: 'addsigner', query:{'signerlist':JSON.stringify(that.signerlist),'cid':that.cid}});
        }
      },function(error){
        console.log(error);
      });
    },
    goback: function () {
      history.go(-1); //后退1页
    }
  },
  components:{
     cheader
  }
}
</script>
<style>
.savesigner .mint-cell-text{
  color:#7d7d7d;
}
</style>



// WEBPACK FOOTER //
// src/module/contract/SaveSigner.vue